const PageTemplate = ({ title, description }) => {
  return (
    <div style={{
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '60px 40px',
      textAlign: 'center'
    }}>
      <h1 style={{
        fontFamily: 'Playfair Display, serif',
        fontSize: '48px',
        marginBottom: '20px',
        background: 'var(--accent-gradient)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text'
      }}>
        {title}
      </h1>
      <p style={{ color: 'var(--text-secondary)', fontSize: '18px' }}>
        {description}
      </p>
    </div>
  );
};

export { default as Catalog } from './Catalog';
export { default as Profile } from './Profile';
export { default as History } from './History';
export { default as Bookmarks } from './Bookmarks';
export { default as Watch } from './Watch';
export { default as Settings } from './Settings';
export { default as My } from './Profile';
export { default as Top100 } from './Top100';
export { default as New } from './New';
export { default as Ongoing } from './Ongoing';
export const Genres = () => <PageTemplate title="Жанры" description="Все жанры дорам" />;
export const Countries = () => <PageTemplate title="Страны" description="Дорамы по странам" />;
export { default as Lakorns } from './Lakorns';
export { default as TopUsers } from './TopUsers';
export { default as UserProfile } from './UserProfile';
export { default as Notifications } from './Notifications';
